export default __webpack_public_path__ + "static/media/Newsletter 014.1b8e194a.png";